// extracted by mini-css-extract-plugin
export default {"page":"Privacy_page__d9yJn","title":"Privacy_title__X8e7x","updated":"Privacy_updated__JY81K"};